import ConversationListView , {OfficeItemView, UserChatItemView} from './conversation-list';
import FriendListView from './friend-list';
import FriendApplyListView from './apply-list';
import ApplyConfirm from './apply-confirm';
import OfflineConfirm from './offline-confirm';
import ChatMsgListView from './chatmsg-list';

export {
	ConversationListView,
	OfficeItemView,
	UserChatItemView,
	FriendListView,
	FriendApplyListView,
	ApplyConfirm,
	OfflineConfirm,
	ChatMsgListView
}


// WEBPACK FOOTER //
// ./js/im/views/index.js